import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import upcoming from '@/assets/images/itinerary/upcoming.png'
import inProgress from '@/assets/images/itinerary/inprogress.png'
import completed from '@/assets/images/itinerary/completed.png'
import last from '@/assets/images/itinerary/last.png'


export default /*#__PURE__*/_defineComponent({
  __name: 'WheelsItineraryItem',
  props: {
    isLastStop: { type: Boolean },
    isInProgress: { type: Boolean },
    isCompleted: { type: Boolean },
    isModified: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  isLastStop?: boolean
  isInProgress?: boolean
  isCompleted?: boolean
  isModified?: boolean
};



const icon = computed(() => {
  if (props.isLastStop) {
    return last
  } else if (props.isInProgress) {
    return inProgress
  } else if (props.isCompleted) {
    return completed
  }
  return upcoming
})

const iconAltText = computed(() => {
  if (props.isLastStop) {
    return 'Last Stop Icon'
  } else if (props.isInProgress) {
    return 'In Progress Stop Icon'
  } else if (props.isCompleted) {
    return 'Completed Stop Icon'
  }
  return 'Upcoming Stop Icon'
})

return { __sfc: true,props, icon, iconAltText }
}

})